import type { ThemePreference } from "@repo/shared/types/theme";
import { Icon } from "@repo/ui/components/icon";
import { Toaster as Sonner, type ToasterProps } from "sonner";

import { Spinner } from "./spinner";

interface AppToasterProps extends ToasterProps {
  /** Active theme — Sonner uses this to style toasts */
  theme?: ThemePreference;
}

const Toaster = ({ theme = "system", ...props }: AppToasterProps) => {
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <Icon name="check-circle" className="size-4 text-success" />,
        info: <Icon name="info-circle" className="size-4" />,
        warning: <Icon name="warning" className="size-4" />,
        error: (
          <Icon name="octagon-cross" className="size-4 text-destructive" />
        ),
        loading: <Spinner />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "cn-toast",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
